import React from "react";
import "./styles/ButtonGo.css";

function ButtonGo() {
  return (
    <div className="buttongo">
      <h3>GO!</h3>
    </div>
  );
}

export default ButtonGo;
